var map = {
	"./menuIcon1.png": "f184",
	"./menuIcon2.png": "45e5",
	"./menuIcon20.png": "4a94",
	"./menuIcon3.png": "07ed",
	"./menuIcon4.png": "8597",
	"./menuIcon5.png": "fc06",
	"./menuIcon6.png": "d4c60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b065";